import * as types from './botActionTypes';

const initialState = {
  successStartStart: null,
  successUpdateStart: null,
  botData: null,
  botDataById: null,
  registeredBotData: null,
  filteredBotHistory: null,
  botHistoryData: null,
  botHistoryDataPnlPercentage: null,
  botHistoryDataPnl: null,
  botHistoryGraphData: null,
  botHistoryWinRate: null,
  botHistoryProfitableTrades: null,
  botHistory: null,
  myBotHistoryData: null,
  botHistorySuccess: null,
  botHistorySuccessCustom: null,
  botHistoryCountData: null,
  pnlHistoryData: null,
  error: {
    type: null,
    data: null,
  },
  loadingStates: {
    botData: false,
    registeredBotData: false,
    accountData: false,
    botHistoryData: false,
    pnlHistoryData: false
  },
  apiCompletionStates: {
    botData: false,
    registeredBotData: false,
    accountData: false
  }
};

export const botReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOADING_STATE:
      return {
        ...state,
        loadingStates: {
          ...state.loadingStates,
          [action.payload.loadingType]: action.payload.isLoading
        }
      };

    case types.RESET_LOADING_STATES:
      return {
        ...state,
        loadingStates: {
          botData: false,
          registeredBotData: false,
          accountData: false,
          botHistoryData: false,
          pnlHistoryData: false
        },
        apiCompletionStates: {
          botData: false,
          registeredBotData: false,
          accountData: false
        }
      };

    case types.GET_BOT_REQUEST:
      return {
        ...state,
        loadingStates: {
          ...state.loadingStates,
          botData: true
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          botData: false
        }
      };

    case types.GET_BOT_DATA:
      return {
        ...state,
        botData: action?.payload.result ? { ...action?.payload.result } : null,
        loadingStates: {
          ...state.loadingStates,
          botData: false
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          botData: true
        }
      };

    case types.GET_BOT_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_BOT_ERROR,
          data: action.payload,
        },
        loadingStates: {
          ...state.loadingStates,
          botData: false
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          botData: true
        }
      };

    case types.GET_REGISTERED_BOT_REQUEST:
      return {
        ...state,
        loadingStates: {
          ...state.loadingStates,
          registeredBotData: true
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          registeredBotData: false
        }
      };

    case types.GET_REGISTERED_BOT_DATA:
      return {
        ...state,
        registeredBotData: action?.payload.result ? { ...action?.payload.result } : null,
        loadingStates: {
          ...state.loadingStates,
          registeredBotData: false
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          registeredBotData: true
        }
      };

    case types.GET_REGISTERED_BOT_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_REGISTERED_BOT_ERROR,
          data: action.payload,
        },
        loadingStates: {
          ...state.loadingStates,
          registeredBotData: false
        },
        apiCompletionStates: {
          ...state.apiCompletionStates,
          registeredBotData: true
        }
      };

    case types.GET_BOT_BY_ID_DATA:
      return {
        ...state,
        botDataById: action?.payload.result ? { ...action?.payload.result } : null,
      };

    case types.GET_BOT_BY_ID_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_BOT_BY_ID_ERROR,
          data: action.payload,
        },
      };

    case types.REGISTER_DATA:
      return {
        ...state,
        successStart: action.successStart ? Object.assign({}, action.successStart) : null,
      };

    case types.REGISTER_ERROR:
      return {
        ...state,
        error: {
          type: types.REGISTER_ERROR,
          data: action.payload,
        },
      };

    case types.REGISTER_UPDATE_DATA:
      return {
        ...state,
        successUpdate: action.successUpdate ? Object.assign({}, action.successUpdate) : null,
      };

    case types.REGISTER_UPDATE_ERROR:
      return {
        ...state,
        error: {
          type: types.REGISTER_UPDATE_ERROR,
          data: action.payload,
        },
      };

    case types.GET_BOT_HISTORY_DATA:
      return {
        ...state,
        botHistoryData: action?.payload.result ? action?.payload?.result[0] : null,
        botHistoryDataPnlPercentage: action?.payload ? action?.payload.result[3] : null,
        botHistoryDataPnl: action?.payload ? action?.payload?.result[2] : null,
        botHistoryGraphData: action?.payload ? action?.payload?.result[4]?.graph_data : null,
        botHistoryWinRate: action?.payload ? action?.payload?.result[5]?.win_rate : null,
        botHistoryProfitableTrades: action?.payload ? 
        action?.payload?.result[6]?.profitable_trades : null,
        botHistorySuccess: action?.payload.success ? action?.payload?.success : null,
        botHistoryCountData: action?.payload.result ? action?.payload?.result[1] : null,
        loadingStates: {
          ...state.loadingStates,
          botHistoryData: false
        }
      };

    case types.GET_CUSTOM_BOT_HISTORY_DATA:
      return {
        ...state,
        botHistoryData: action?.payload.result ? action?.payload?.result[0] : null,
        botHistoryDataPnlPercentage: action?.payload ? action?.payload.result[3] : null,
        botHistoryDataPnl: action?.payload ? action?.payload?.result[2] : null,
        botHistoryGraphData: action?.payload ? action?.payload?.result[4]?.graph_data : null,
        botHistorySuccessCustom: action?.payload.success ? action?.payload?.success : null,
        botHistoryCountData: action?.payload.result ? action?.payload?.result[1] : null,
      };

    case types.SET_BOT_HISTORY_SORT_DATA:
      return {
        ...state,
        botHistorySorting: {
          orderBy: action.payload.orderBy,
          order: action.payload.order
        }
      };

    case types.GET_BOT_HISTORY_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_BOT_HISTORY_ERROR,
          data: action.payload,
        },
        loadingStates: {
          ...state.loadingStates,
          botHistoryData: false
        }
      };

    case types.GET_MY_BOT_HISTORY_DATA:
      return {
        ...state,
        myBotHistoryData: action?.payload.result ? action?.payload?.result[0] : null,
      };

    case types.SET_MY_BOT_HISTORY_SORT_DATA:
      return {
        ...state,
        myBotHistorySortData: { ...action.payload.result },
      };

    case types.GET_MY_BOT_HISTORY_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_MY_BOT_HISTORY_ERROR,
          data: action.payload,
        },
      };

    case types.GET_PNL_HISTORY_DATA:
      return {
        ...state,
        pnlHistoryData: action?.payload.result ? { ...action?.payload.result } : null,
        loadingStates: {
          ...state.loadingStates,
          pnlHistoryData: false
        }
      };

    case types.GET_PNL_HISTORY_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_PNL_HISTORY_ERROR,
          data: action.payload.result,
        },
        loadingStates: {
          ...state.loadingStates,
          pnlHistoryData: false
        }
      };

    default:
      return state;
  }
};